import React from "react";
import { Crown, ShieldCheck, SealCheck, Buildings, Handshake, Wrench, User } from "@phosphor-icons/react";

// Every role gets a distinct badge (label, colour, icon).
export const ROLE_META = {
  platform_owner: { label: "Owner", Icon: Crown, cls: "bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300" },
  admin: { label: "Admin", Icon: ShieldCheck, cls: "bg-indigo-100 text-indigo-800 dark:bg-indigo-950/50 dark:text-indigo-300" },
  inspector: { label: "Inspector", Icon: SealCheck, cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-950/50 dark:text-emerald-300" },
  master_distributor: { label: "Master Distributor", Icon: Buildings, cls: "bg-violet-100 text-violet-800 dark:bg-violet-950/50 dark:text-violet-300" },
  reseller: { label: "Reseller", Icon: Handshake, cls: "bg-sky-100 text-sky-800 dark:bg-sky-950/50 dark:text-sky-300" },
  provider: { label: "Provider", Icon: Wrench, cls: "bg-orange-100 text-orange-800 dark:bg-orange-950/50 dark:text-orange-300" },
  org_admin: { label: "Member", Icon: User, cls: "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300" },
  user: { label: "Member", Icon: User, cls: "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300" },
};

export const RoleBadge = ({ role, pending = false, className = "" }) => {
  const meta = ROLE_META[role] || ROLE_META.user;
  const { label, Icon, cls } = pending
    ? { label: "Inspector · pending", Icon: SealCheck, cls: "bg-amber-100 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300" }
    : meta;
  return (
    <span data-testid={`role-badge-${pending ? "inspector-pending" : role}`}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold ${cls} ${className}`}>
      <Icon size={11} weight="fill" /> {label}
    </span>
  );
};

export default RoleBadge;
